// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3zjbJ","checkboxCol":"Table_checkboxCol__1xYb_","emailCol":"Table_emailCol__2NVPf","actionCol":"Table_actionCol__VvC9I"};